Namespace 'Monitoring.Models.SocialContents.LinkedIn.Builders'

class Monitoring.Models.SocialContents.LinkedIn.Builders.LinkedInAuthorBuilder

  setId: (id) ->
    @id = id

  getId: ->
    @id

  setUsername: (username) ->
    @username = username

  getUsername: ->
    @username

  setName: (name) ->
    @name = name

  getName: ->
    @name

  setProfilePictureUrl: (profilePictureUrl) ->
    @profilePictureUrl = profilePictureUrl

  getProfilePictureUrl: ->
    @profilePictureUrl

  build: ->
    new Monitoring.Models.SocialContents.LinkedIn.LinkedInAuthor(@)
